import React, { forwardRef } from 'react';
import { useTheme, Theme } from '@mui/material/styles';
import { Card, CardContent, CardHeader } from '@mui/material';
import { Typography } from '@ts/storybook';

interface MainCardProps {
  border?: boolean;
  boxShadow?: boolean;
  content?: boolean;
  contentSX?: object;
  darkTitle?: boolean;
  divider?: boolean;
  elevation?: number;
  secondary?: React.ReactNode;
  shadow?: string;
  sx?: object;
  title?: string | React.ReactNode;
  codeHighlight?: boolean;
  children?: React.ReactNode;
}

const MainCard = forwardRef<HTMLDivElement, MainCardProps>(
  (
    {
      border = true,
      boxShadow,
      children,
      content = true,
      contentSX = {},
      darkTitle,
      elevation,
      secondary,
      shadow,
      sx = {},
      title,
      codeHighlight,
      ...others
    },
    ref
  ) => {
    const theme: Theme = useTheme();
    boxShadow = theme.palette.mode === 'dark' ? boxShadow || true : boxShadow;
    const headerSX = {
      p: 2.5,
      '& .MuiCardHeader-action': { m: '0px auto', alignSelf: 'center' },
    };

    return (
      <Card
        elevation={elevation || 0}
        ref={ref}
        {...others}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          border: border ? '1px solid' : 'none',
          borderRadius: 2,
          borderColor: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main,
          ...sx,
        }}
      >
        {!darkTitle && title && (
          <CardHeader sx={headerSX} titleTypographyProps={{ variant: 'subtitle1' }} title={title} action={secondary} />
        )}
        {darkTitle && title && <CardHeader sx={headerSX} title={<Typography variant="h3" text={title} />} action={secondary} />}
        {content && <CardContent sx={{ flex: 1, ...contentSX }}>{children}</CardContent>}
        {!content && children}
      </Card>
    );
  }
);

export default MainCard;
